import browser from "webextension-polyfill";
import { matchingElementFoundKey, ytHavenEmbeddedPlayerIssue, ytHavenMetaTagFound, ytHavenNonEmbeddableFound, ytHavenNonPlayableFound, } from "../shared/index.js";
import { getIframePlayer, getToggleState, isInHavenExperiment, isWatchPage, videoContextStore, } from "./shared.js";
import { removeEmbedPlayer, removeInfoBox, start as startEmbedExperiment, } from "./embed-haven.js";
import { startPause, resumeCurrentVideo, pauseCurrentVideos, } from "./pause-video.js";
const ytPlayerSelector = "ytd-player";
var PlayabilityStatus;
(function (PlayabilityStatus) {
    PlayabilityStatus["OK"] = "OK";
})(PlayabilityStatus || (PlayabilityStatus = {}));
const addExperiments = async () => {
    const targetElement = document.querySelector(ytPlayerSelector);
    if (!targetElement) {
        return;
    }
    await Promise.all([
        startEmbedExperiment(targetElement),
    ]);
};
const removeExperiments = () => {
    removeEmbedPlayer();
    removeInfoBox();
};
const navigationListener = async (event, toggleState = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const endpoint = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.endpoint;
    const playerResponse = (_c = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.playerResponse;
    const pageData = (_e = (_d = event === null || event === void 0 ? void 0 : event.detail) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.response;
    const videoId = (_f = endpoint === null || endpoint === void 0 ? void 0 : endpoint.watchEndpoint) === null || _f === void 0 ? void 0 : _f.videoId;
    if (!isWatchPage() || !(await shouldStartExperiment()) || !videoId) {
        removeExperiments();
        return;
    }
    if (toggleState) {
        pauseCurrentVideos();
    }
    const playlistId = (_g = endpoint === null || endpoint === void 0 ? void 0 : endpoint.watchEndpoint) === null || _g === void 0 ? void 0 : _g.playlistId;
    const isEmbeddable = (_h = playerResponse === null || playerResponse === void 0 ? void 0 : playerResponse.playabilityStatus) === null || _h === void 0 ? void 0 : _h.playableInEmbed;
    const playabilityStatus = (_j = playerResponse === null || playerResponse === void 0 ? void 0 : playerResponse.playabilityStatus) === null || _j === void 0 ? void 0 : _j.status;
    if (!isEmbeddable || playabilityStatus !== PlayabilityStatus.OK) {
        resumeCurrentVideo();
        removeExperiments();
        void browser.runtime.sendMessage({
            type: !isEmbeddable ? ytHavenNonEmbeddableFound : ytHavenNonPlayableFound,
            errorCode: playabilityStatus,
        });
        return;
    }
    const nextVideoId = (_r = (_q = (_p = (_o = (_m = (_l = (_k = pageData === null || pageData === void 0 ? void 0 : pageData.contents) === null || _k === void 0 ? void 0 : _k.twoColumnWatchNextResults) === null || _l === void 0 ? void 0 : _l.autoplay) === null || _m === void 0 ? void 0 : _m.autoplay) === null || _o === void 0 ? void 0 : _o.sets[0]) === null || _p === void 0 ? void 0 : _p.autoplayVideo) === null || _q === void 0 ? void 0 : _q.watchEndpoint) === null || _r === void 0 ? void 0 : _r.videoId;
    const autoplayEnabled = (_w = (_v = (_u = (_t = (_s = pageData === null || pageData === void 0 ? void 0 : pageData.playerOverlays) === null || _s === void 0 ? void 0 : _s.playerOverlayRenderer) === null || _t === void 0 ? void 0 : _t.autonavToggle) === null || _u === void 0 ? void 0 : _u.autoplaySwitchButtonRenderer) === null || _v === void 0 ? void 0 : _v.enabled) !== null && _w !== void 0 ? _w : true;
    const startSeconds = (_x = endpoint === null || endpoint === void 0 ? void 0 : endpoint.watchEndpoint) === null || _x === void 0 ? void 0 : _x.startTimeSeconds;
    videoContextStore.setVideoContext({
        videoId,
        isEmbeddable,
        startSeconds,
        autoplayEnabled,
        nextVideoId,
        playlistId,
    });
    await addExperiments();
};
const havenElementExits = () => {
    let metaTag = document.getElementById("yt-haven");
    if (metaTag) {
        return true;
    }
    metaTag = document.createElement("meta");
    metaTag.id = "yt-haven";
    (document.head || document.documentElement).prepend(metaTag);
    return false;
};
const iFrameErrorListener = (event) => {
    var _a, _b;
    const playerElem = getIframePlayer();
    if (playerElem &&
        playerElem instanceof HTMLIFrameElement &&
        event.source === playerElem.contentWindow &&
        "data" in event &&
        typeof event.data === "string") {
        const eventData = JSON.parse(event.data);
        const errorCode = (_b = (_a = eventData === null || eventData === void 0 ? void 0 : eventData.info) === null || _a === void 0 ? void 0 : _a.videoData) === null || _b === void 0 ? void 0 : _b.errorCode;
        if ((eventData === null || eventData === void 0 ? void 0 : eventData.event) === "initialDelivery" && errorCode) {
            void browser.runtime.sendMessage({
                type: ytHavenEmbeddedPlayerIssue,
                errorCode,
            });
        }
    }
};
const shouldStartExperiment = async () => {
    const matchingElementFound = await browser.storage.local.get(matchingElementFoundKey);
    return ((await isInHavenExperiment()) &&
        typeof matchingElementFound[matchingElementFoundKey] !== "undefined");
};
export async function start() {
    const [shouldStartExp, toggleState] = await Promise.all([
        shouldStartExperiment(),
        getToggleState(),
    ]);
    if (!shouldStartExp) {
        return;
    }
    if (havenElementExits()) {
        void browser.runtime.sendMessage({
            type: ytHavenMetaTagFound,
        });
        return;
    }
    if (toggleState) {
        startPause();
    }
    window.addEventListener("yt-navigate-finish", (event) => {
        void navigationListener(event, Boolean(toggleState));
    });
    window.addEventListener("message", (event) => {
        iFrameErrorListener(event);
    });
}
